import { render, staticRenderFns } from "./GiftcardForm.vue?vue&type=template&id=c95f268c&scoped=true&"
import script from "./GiftcardForm.vue?vue&type=script&lang=js&"
export * from "./GiftcardForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95f268c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c95f268c')) {
      api.createRecord('c95f268c', component.options)
    } else {
      api.reload('c95f268c', component.options)
    }
    module.hot.accept("./GiftcardForm.vue?vue&type=template&id=c95f268c&scoped=true&", function () {
      api.rerender('c95f268c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/GiftcardForm.vue"
export default component.exports